export default "__VITE_ASSET__BBe51oeI__"